/*global define:false */
define(function () {
  var utilities = {};
  var internalStorage = {};

  utilities.getLocalStorage = function() {
    return window.localStorage;
  };

  utilities.getSessionStorage = function() {
    return window.sessionStorage;
  };

  utilities.getInternalStorage = function() {
    internalStorage.getItem = function (key) {
      return internalStorage[key];
    };

    internalStorage.setItem = function (key, value) {
      internalStorage[key] = value;
    };

    internalStorage.clear = function () {
      internalStorage = {};
    };

    return internalStorage;
  };

  utilities.getStorage = function () {
    var windowStorage;
    try {
      var localStorage = utilities.getLocalStorage();
      if (typeof localStorage !== 'undefined') {
        windowStorage = localStorage;
      } else {
        windowStorage = utilities.getSessionStorage();
      }
    } catch (e) {
            // ignored
    }

    if (typeof windowStorage === 'undefined'){
      windowStorage = utilities.getInternalStorage();

    }

    return windowStorage;
  };

  utilities.isCORSRequest = function(url) {
    var parser = document.createElement('a');
    parser.href = url;
    return parser.host !== window.location.host;
  };

  utilities.useXDomainRequest = function(url) {
    return utilities.isCORSRequest(url) && !!window.XDomainRequest &&
            (navigator.appVersion.indexOf('MSIE 8.') !== -1 || navigator.appVersion.indexOf('MSIE 9.') !== -1);
  };

  utilities.getCookieValue = function(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') { c = c.substring(1,c.length); }
      if (c.indexOf(nameEQ) === 0) { return c.substring(nameEQ.length,c.length); }
    }
    return null;
  };

  return utilities;
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/lib/herment/utils.js